import Vue from 'vue';
import { i18n } from '@/plugins/vue-i18n';
import {
  Actions, chip, metadata, tooltip,
} from '@/modules/list/config/utils';

function getFullName(item) {
  if (!item.ancestors
    || item.ancestors.length === 0) {
    return item.name || item.title;
  }
  // Construye el "árbol" de la categoría si tiene ancestros
  // ej deportes / futbol / madridfc
  return []
    .concat(item.ancestors)
    .concat(item)
    .map(element => element.name)
    .join(' / ');
}

export default function formatCategory(category) {
  const fullName = getFullName(category);
  return {
    id: category.id,
    title: fullName,
    image: {
      value: category.thumbnailUrl,
      alt: category.title,
    },
    icon: {
      name: Vue.filter('taxonomyIcon')(category.type),
    },
    editor: 'entity',
    type: category.type,
    url: category.publicUrl,
    chips: [
      tooltip(
        chip(
          i18n.tc(`message.taxonomy.type.${category.type}`, 1).toUpperCase().slice(0, 3),
          '#4e82d1',
          '#ffffff',
        ),
        i18n.tc(`message.taxonomy.type.${category.type}`, 1),
      ),
      tooltip(chip(category.id, null, null, null, { name: 'clipboard-copy', value: category.id }), i18n.t('message.metadata.id')),
      tooltip(
        chip(`Sección padre: ${category.parentId ? category.parentId : 'Raíz'}`, null, null, null, { name: 'add-filter-search', field: 'parentId', value: category.parentId }),
        'Cuando tengamos datos pondrá solo el nombre de la sección padre',
      ),
      tooltip(
        chip(`${category.hasChildren ? 'XX hijas' : 'No tiene hijas'}`, null, null, null,
          category.hasChildren ? { name: 'add-filter-search', field: 'parentId', value: category.id } : null),
        'Este chip solo aparecera cuando tengamos datos de las hijas',
      ),
      tooltip(chip(category.modificationDate ? Vue.filter('formatDate')(category.modificationDate) : null), i18n.t('message.metadata.modificationDate')),
      tooltip(
        chip(
          category.creatorStaff ? category.creatorStaff.nick : null,
          null,
          null,
          category.creatorStaff ? {
            src: category.creatorStaff.avatarUrl,
            alt: category.creatorStaff.nick,
          } : null,
          { name: 'add-filter-search', field: 'staffCreators', value: category.creatorStaff ? category.creatorStaff.id : null },
        ),
        i18n.t('message.metadata.creationStaffId'),
      ),
    ].filter(c => !!c.value),
    metadata: [
      metadata(i18n.t('message.metadata.fullName'), fullName),
      metadata(i18n.t('message.metadata.type'), i18n.tc(`message.taxonomy.type.${category.type}`, 1)),
      metadata(i18n.t('message.metadata.publicUrl'), category.publicUrl ? category.publicUrl : null, true),
      metadata(i18n.t('message.metadata.createdBy'), category.creatorStaff ? category.creatorStaff.nick : null),
      metadata(i18n.t('message.metadata.creationSite'), category.creationSite ? category.creationSite.name : null),
      metadata(i18n.t('message.metadata.crossdomains'), category.crossdomains ? formatCategory(category) : null),
      metadata(i18n.t('message.metadata.creationDate'), Vue.filter('formatDate')(category.creationDate)),
      metadata(i18n.t('message.metadata.lastModifiedDate'), Vue.filter('formatDate')(category.modificationDate)),
      metadata(i18n.t('message.metadata.lastModifiedBy'), category.lastModificationStaff ? category.lastModificationStaff.nick : null),
      metadata(i18n.t('message.metadata.active'), typeof category.active === 'boolean' ? Vue.filter('formatTrueFalse')(category.active) : null),
      metadata(i18n.t('message.metadata.archived'), typeof category.archived === 'boolean' ? Vue.filter('formatTrueFalse')(category.archived) : null),
    ],
    hasChildren: category.hasChildren, // TODO(dalvarez) llevar a acciones
    actions: [
      Actions.LINK,
    ],
  };
}
